// extracted by mini-css-extract-plugin
export default {"wrap-text":"HolonTemplateName_wrap-text__G8GKo"};